import { ApplicationShowcase } from '../components/application/ApplicationShowcase';
import { usePageSeo } from '../hooks/usePageSeo';
import { PAGE_SEO } from '../lib/seo';
import '../styles/application-page.css';

export function ApplicationPage() {
  usePageSeo(PAGE_SEO.application);

  return <ApplicationShowcase />;
}
